import React, { Component } from 'react';

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { CardText } from 'material-ui/Card';
import { Card } from 'material-ui/Card';

import LeaseHoldersFieldArray from './LeaseHoldersFieldArray';
import AdditionalOccupantsFieldArray from './AdditionalOccupantsFieldArray';

import { deleteAdditionalOccupant } from 'actions/landlordTenantsActions';
import { deleteCotenant } from 'actions/landlordTenantsActions';
import { showFailure } from 'actions/notificationActions';

let TenantsForm = class extends Component {
  deleteCotenant = cotenantID => {
    this.props
      .deleteCotenant(this.props.leaseDetails.id, cotenantID)
      .then(this._updateLeaseOverview);
  };

  deleteAdditionalOccupant = occupantID => {
    this.props
      .deleteAdditionalOccupant(this.props.leaseDetails.id, occupantID)
      .then(this._updateLeaseOverview);
  };

  _updateLeaseOverview = () => {
    this.props.getLeaseData(this.props.leaseDetails.id);
    this.props.getRentRollData();
  };

  render() {
    const { initialValues } = this.props;
    const styles = {
      transactionCard: {
        color: '#424242 !important',
        fontFamily: '"Circular", sans-serif !important',
        height: '100%',
        borderRadius: '8px',
        marginBottom: '15px',
      },
    };

    return (
      <form autoComplete="off">
        <Card style={styles.transactionCard}>
          <CardText style={{ padding: '0' }}>
            <LeaseHoldersFieldArray
              enableAddAndRemove={this.props.leaseDetails.is_renewing}
              deleteCotenant={this.deleteCotenant}
              showFailure={this.props.showFailure}
              disabled={!initialValues.editable}
            />
          </CardText>
        </Card>

        <Card style={styles.transactionCard}>
          <CardText style={{ padding: '0' }}>
            <AdditionalOccupantsFieldArray
              enableAddAndRemove={this.props.leaseDetails.is_renewing}
              deleteAdditionalOccupant={this.deleteAdditionalOccupant}
              showFailure={this.props.showFailure}
              disabled={!initialValues.editable}
            />
          </CardText>
        </Card>
      </form>
    );
  }
};

export default compose(
  connect(
    (store, ownProps) => ({
      form: ownProps.formName,
      initialValues: store.leaseDetails.leaseDetails,
    }),
    { deleteCotenant, deleteAdditionalOccupant, showFailure }
  ),
  reduxForm({
    destroyOnUnmount: true,
    enableReinitialize: true,
  })
)(TenantsForm);
